import { FC } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Modal from "components/Modal";

interface AfterMintItemModalProps {
  isOpen?: boolean;
  itemName: string;
}

const AfterMintItemModal: FC<AfterMintItemModalProps> = ({
  isOpen,
  itemName,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      title="Success!"
      disableBackdropClick
      hideCloseButton
    >
      <Box maxWidth={350} sx={{ minWidth: { md: 350 } }}>
        <Typography align="center">
          You've successfully minted your item <strong>{itemName}</strong>. You
          can close this page, wait a couple of minutes, and scan the NFC Tag
          from your item again. Once you do, you will see the item page with
          item history and yourself assigned as the owner.
        </Typography>
      </Box>
    </Modal>
  );
};

export default AfterMintItemModal;
